import { createSlice } from "@reduxjs/toolkit";
import { fetchIndustrysectorchildItems } from "./IndustrysectorchildThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const industrysectorchildItems = createSlice({
  name: "industrysectorchild",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchIndustrysectorchildItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndustrysectorchildItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchIndustrysectorchildItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default industrysectorchildItems.reducer;